<main class="main-content" id="main-content" aria-label="Main Content">
  <div class="container">
    <nav
      class="breadcrumb-container mt-5"
      role="navigation"
      aria-label="Fil d'ariane"
    >
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [href]="homeLink" i18n>Accueil</a></li>
        <li class="breadcrumb-item">
          <a [href]="servicesLink" i18n>Services</a>
        </li>
        <li class="breadcrumb-item">
          <a [href]="toolsLink" i18n>Outils et données</a>
        </li>
      </ol>
    </nav>
    <div class="row">
      <div class="col-md-8">
        <header class="content-header">
          <h1 class="mb-3" i18n>
            Outil de calcul : contributions pour logements sociaux ou abordables
            hors-marché et logements familiaux
          </h1>
          <div class="content-header-extras mb-0 d-print-none">
            <div class="content-header-extras-item list-inline-interpunct mb-0">
              <div class="list-inline-item" i18n>
                Mis à jour le {{ lastUpdate | date: 'longDate' }}
              </div>
            </div>
            <div class="content-header-extras-item list-inline-interpunct mb-0">
              <div>
                <span i18n>Relié à &nbsp;</span
                ><a
                  [href]="ruleLink"
                  style="cursor: pointer"
                  title="link title text"
                  i18n
                  >Métropole mixte : les grandes lignes du règlement</a
                >
              </div>
            </div>
          </div>
        </header>
        <div class="mb-10">
          <app-calculator></app-calculator>
        </div>

        <div class="mb-5 d-print-none">
          <div class="alert alert-info alert-with-icon" role="alert">
            <div class="alert-icon-container">
              <span class="icon icon-info" aria-hidden="true"></span>
            </div>
            <div class="alert-content">
              <div class="alert-heading" i18n>Note</div>
              <span i18n
                >Cet outil a été conçu pour vous aider à planifier vos projets.
                Les résultats générés par l'outil ne sont fournis qu'à titre
                indicatif et reflètent le cadre normatif actuellement en
                vigueur.</span
              >
              <span>&nbsp;</span>
              <br /><br />
              <span i18n
                >Des questions? Contactez le Service de la stratégie immobilière et de l'habitation à</span
              >
              <span
                >&nbsp;<a href="mailto: inclusion@montreal.ca"
                  >inclusion&#64;montreal.ca</a
                ></span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-1"></div>
      <div class="col-md-3 d-print-none">
        <div class="mt-3">
          <h3 i18n>Outils</h3>
          <div class="pl-mb-4">
            <ul class="list-group list-group-xl">
              <li class="list-group-item list-group-item-action">
                <a [href]="helpLink" class="tools-link">
                  <span class="icon icon-help" aria-hidden="true"></span>
                  <span class="list-group-item-label" i18n>Aide</span>
                </a>
              </li>
              <li class="list-group-item list-group-item-action">
                <a tabindex="0" (click)="onPrint()" class="tools-link">
                  <span class="icon icon-print" aria-hidden="true"></span>
                  <span class="list-group-item-label" i18n>Imprimer</span>
                </a>
              </li>
              <li class="list-group-item list-group-item-action">
                <a [href]="gridLink" class="tools-link">
                  <span class="icon icon-info" aria-hidden="true"></span>
                  <span class="list-group-item-label" i18n>Grid</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<router-outlet name="print"></router-outlet>
